import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { easeIn, easeOut } from '../utils/curves';
import { mediumDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
export var slideInAnimation = function slideInAnimation(from, state, fade) {
  var initial = state === 'entering' ? '0%' : '100%';
  var end = state === 'entering' ? '100%' : '0%';
  var fromMap = {
    top: 'translate3d(0, -100%, 0)',
    right: 'translate3d(100%, 0, 0)',
    bottom: 'translate3d(0, 100%, 0)',
    left: 'translate3d(-100%, 0, 0)'
  };
  var animateOpacity = fade === 'inout' || fade === 'in' && state === 'entering' || fade === 'out' && state === 'exiting';
  return _defineProperty(_defineProperty({}, initial, {
    transform: fromMap[from],
    opacity: animateOpacity ? 0 : 1
  }), end, {
    transform: 'none',
    opacity: 1
  });
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */
var SlideIn = function SlideIn(_ref2) {
  var children = _ref2.children,
    enterFrom = _ref2.enterFrom,
    exitTo = _ref2.exitTo,
    _ref2$fade = _ref2.fade,
    fade = _ref2$fade === void 0 ? 'none' : _ref2$fade,
    _ref2$duration = _ref2.duration,
    duration = _ref2$duration === void 0 ? mediumDurationMs : _ref2$duration,
    isPaused = _ref2.isPaused,
    onFinish = _ref2.onFinish,
    _ref2$animationTiming = _ref2.animationTimingFunction,
    animationTimingFunction = _ref2$animationTiming === void 0 ? function (state) {
      return state === 'entering' ? easeOut : easeIn;
    } : _ref2$animationTiming;
  return /*#__PURE__*/React.createElement(KeyframesMotion, {
    duration: duration,
    enteringAnimation: slideInAnimation(enterFrom, 'entering', fade),
    exitingAnimation: slideInAnimation(exitTo || enterFrom, 'exiting', fade),
    animationTimingFunction: animationTimingFunction,
    isPaused: isPaused,
    onFinish: onFinish
  }, children);
};
export default SlideIn;